import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a95dbd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { h, ref } from 'vue';
import { EMessage } from '@aciga/e-ui-next';
import { ElAlert, ElMessageBox } from 'element-plus';
import dayjs from 'dayjs';
import { deleteProject } from '@/api/project';
import LogDrawer from '@/pages/component/LogDrawer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'projectTable',
  props: {
    tableList: {},
    loading: { type: Boolean }
  },
  emits: ['on-edit', 'update-table'],
  setup(__props: any, { emit: __emit }) {



const logBizNo = ref<string>('');
const logMianName = ref<string>('');
const drawerShow = ref<boolean>(false);

const emit = __emit;

const onEdit = (row: Project.ProjectItem) => {
  emit('on-edit', row);
};

const onDelete = (row: Project.ProjectItem) => {
  // @ts-ignore
  ElMessageBox.confirm(
    h(ElAlert, {
      title: '确认删除该项目',
      type: 'warning',
      showIcon: true,
      closable: false
    }),
    '删除项目',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      customClass: 'e-message-box e-theme-cm',
      confirmButtonClass: 'e-button el-button--main e-theme-cm',
      cancelButtonClass: 'e-button el-button--secondary e-theme-cm',
      effect: 'cm'
    }
  ).then(async () => {
    const res = await deleteProject(row.projectId as number);
    if (`${res.code}` === '0') {
      EMessage.success('删除成功');
      emit('update-table');
    }
  });
};

const showLog = (row: Project.ProjectItem) => {
  const { projectName, projectId } = row;
  logBizNo.value = `${projectId}`;
  logMianName.value = projectName;
  drawerShow.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_e_table_column = _resolveComponent("e-table-column")!
  const _component_e_button = _resolveComponent("e-button")!
  const _component_e_table = _resolveComponent("e-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_e_table, {
      data: _ctx.tableList,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_e_table_column, {
          label: "项目ID",
          prop: "projectId",
          "min-width": "95px",
          align: "center"
        }),
        _createVNode(_component_e_table_column, {
          label: "所属系统",
          prop: "sysName",
          "min-width": "95px",
          align: "center"
        }),
        _createVNode(_component_e_table_column, {
          label: "项目名称",
          prop: "projectName",
          "min-width": "200px"
        }),
        _createVNode(_component_e_table_column, {
          label: "项目英文名称",
          prop: "projectEngName",
          "min-width": "200px"
        }),
        _createVNode(_component_e_table_column, {
          label: "icon",
          prop: "icon",
          "min-width": "95px",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("img", {
              class: "project-icon",
              src: scope.row.icon
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }),
        _createVNode(_component_e_table_column, {
          label: "项目地址",
          prop: "projectUrl",
          "min-width": "200px"
        }),
        _createVNode(_component_e_table_column, {
          label: "项目排序",
          prop: "order",
          "min-width": "100px"
        }),
        _createVNode(_component_e_table_column, {
          label: "添加时间",
          "min-width": "200px"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_unref(dayjs)(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_e_table_column, {
          label: "操作",
          "min-width": "200px",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_e_button, {
              size: "mini",
              onClick: ($event: any) => (onEdit(scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode("编辑")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_e_button, {
              size: "mini",
              type: "warning",
              plain: "",
              onClick: ($event: any) => (onDelete(scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_e_button, {
              size: "mini",
              plain: "",
              onClick: ($event: any) => (showLog(scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode("日志")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(LogDrawer, {
      "drawer-visible": drawerShow.value,
      "onUpdate:drawerVisible": _cache[0] || (_cache[0] = ($event: any) => ((drawerShow).value = $event)),
      type: "PROJECT",
      "biz-no": logBizNo.value,
      "mian-name": logMianName.value
    }, null, 8, ["drawer-visible", "biz-no", "mian-name"])
  ], 64))
}
}

})